module.exports = __webpack_public_path__ + "img/menu-team-white.0d8ae34e.svg";